<template>
  <div class="cellinput-wrapper">
    <input autofocus  autocomplete="one-time-code" type="tel" ref="input" class="iteminput" v-model="value" :maxlength="maxLength" @input="doinput"/>
    <div class="item-wrapper" @click="inputfouce">
      <div ref="inputdiv" :style="{width:'2.1rem',margin:'.25rem',background: bgc}" @click="activeindex = index" class="item" :class="index == activeindex?'active':''" v-for="(item,index) in maxLength" :key="index"></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  name: "CellInput",
  props:{
    maxLength:{          //输入框的最大长度
      type:Number,
      default:6
    },
    gutter:{            //输入框之间的间隔
      type:Number,
      default:7
    },
    bgc:{
      type: String,
      default: ''
    }
  },
  data(){
    return {
      value:"",
      activeindex:0,    //这个是为了显示当前活动的格子
      inputdivElements:[]  //这是所有格子的一个数组
    }
  },
  mounted() {
    this.inputdivElements = this.$refs.inputdiv;
    this.$refs.input.focus()
  },
  computed:{
    cellwidth(){
      return Math.floor(100/this.maxLength)+"%";    //根据格子数量来计算格子宽子， 这里好像可以不用计算属性的（就这样吧）
    }
  },
  methods:{
    closeCode(){
      this.value = '',
      this.doinput()
    },
    inputfouce(){
      this.$refs.input.focus();   //让input框得到焦点
      this.$refs.input.selectionStart = this.activeindex;    //设置光标的具体位置
    },

    doinput(){
      this.value = this.value.replace(/[^0-9]/g,'')
      let inputstrtoarr = this.value.split("");   //把 input 中的数据分割成数组
      this.activeindex = inputstrtoarr.length;
      if(inputstrtoarr.length<this.maxLength){
        let i = this.maxLength - inputstrtoarr.length;
        for(let j=0;j<i;j++){
          inputstrtoarr.push("");                //把数组长度补齐 到指定的最大长度， 没有的使用  空字符串真充
        }
      }
      inputstrtoarr.forEach((i,index)=>{
        this.inputdivElements[index].innerText=i     //在格子中写入数据
      })
      if(this.value.length==6){
        this.$refs.input.blur()
        this.$emit('inputValue',this.value)
      }
    }
  },
}
</script>

<style scoped lang="less">
.cellinput-wrapper{
  margin-top: 1rem;
  width:100%;
  display:flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .iteminput{
    width:100%;
    height:.01rem;
    border:none;
    background:transparent;     // 这段是让input框 消失  这里我想也可以使用  hidden让它不显示， 更方便一点（没有试过， 有兴趣的可以试下）
    position: absolute;
    top:0px;
    color: transparent;     //input 框是透明的， 看不见
    opacity: 0;
  }
  .item-wrapper{
    height:2.5rem;
    width:100%;
    display:flex;
    justify-content: center;
    background:transparent;
    .item{
      width:100px;
      height:2.5rem;
      background-color: #E4E4E4;
      display:flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      font-weight: bold;
      box-sizing: border-box;
      border-radius: .15rem;
    }
    .active{
      background:#B4B4B4;
      &::before{
        content: "";
        height: 1rem;
        width: 1px;
        background-color: black;
        position: absolute;
        top: 1.5rem;
        transform: translateY(-50%);
        animation: cursor 2s infinite;
      }
      @keyframes cursor{
        0%{
          opacity: 0;
        }
        50%{
          opacity: 0.5;
        }
        100%{
          opacity: 1;
        }
      }
    }
  }

}
</style>
